import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { useLayoutEffect, useMemo } from 'react'
import { connect } from 'react-redux';
import { COUNTER_BUS_MAINTENANCE_STAY } from '../../../../config/columns';
import Table from '../../../common/Table';
import { clearBusMaintenanceStayDemand, getBusMaintenanceStayDemand } from '../../../../actions';
import { tzNormalizeDate } from '../../../../utils/date';
import { INT_DATE_FORMAT } from '../../../../config/locale';

const BusMaintenanceStayDemandTable = ({
  busMaintenanceStayDemand,
  busMaintenanceStayDemandLoading,
  dispatchGetBusMaintenanceStayDemand,
  dispatchClearBusMaintenanceStayDemand
}) => {

  useLayoutEffect(() => {
    dispatchGetBusMaintenanceStayDemand({
      fromDateString: tzNormalizeDate({ format: INT_DATE_FORMAT }),
      toDateString: tzNormalizeDate({ format: INT_DATE_FORMAT }),
    });

    return () => {
      dispatchClearBusMaintenanceStayDemand();
    }
  }, []);

  const demandData = useMemo(() => {
    if (!busMaintenanceStayDemand) return [];

    let demand = null;

    if (busMaintenanceStayDemand.toJS) {
      demand = busMaintenanceStayDemand.toJS();
    } else if (typeof busMaintenanceStayDemand === 'object') {
      demand = busMaintenanceStayDemand;
    }

    if (!demand) return [];

    let { serviceTypeDemands } = demand;

    if (!serviceTypeDemands && demand.content) {
      ({ serviceTypeDemands } = demand.content);
    }

    if (!serviceTypeDemands && Array.isArray(demand)) {
      serviceTypeDemands = demand;
    }

    if (!Array.isArray(serviceTypeDemands) || serviceTypeDemands.length === 0) {
      return [];
    }

    const mappedData = serviceTypeDemands.map((service, index) => {
      const routeDirectionDemand = service.routeDirectionDemand || {};

      return {
        _id: service.serviceTypeId || index,
        serviceTypeName: service.serviceTypeName || '',
        limaToProvinceCount: routeDirectionDemand.limaToProvinceCount || 0,
        provinceToProvinceCount: routeDirectionDemand.provinceToProvinceCount || 0,
        provinceToLimaCount: routeDirectionDemand.provinceToLimaCount || 0,
        total: service.total || 0,
      };
    });

    const totals = mappedData.reduce(
      (acc, item) => ({
        limaToProvinceCount: acc.limaToProvinceCount + item.limaToProvinceCount,
        provinceToProvinceCount: acc.provinceToProvinceCount + item.provinceToProvinceCount,
        provinceToLimaCount: acc.provinceToLimaCount + item.provinceToLimaCount,
        total: acc.total + item.total,
      }),
      {
        limaToProvinceCount: 0,
        provinceToProvinceCount: 0,
        provinceToLimaCount: 0,
        total: 0
      }
    );

    return [
      ...mappedData,
      {
        _id: 'total-row',
        serviceTypeName: 'Total',
        ...totals,
      }
    ];
  }, [busMaintenanceStayDemand]);

  const demandPageSize = demandData.length > 0 ? demandData.length : 5;


  return (
    <Table
      key={`demand-${demandData.length}-${Date.now()}`}
      columns={COUNTER_BUS_MAINTENANCE_STAY}
      data={demandData}
      defaultPageSize={demandPageSize}
      showPagination={false}
      manual={false}
      loading={busMaintenanceStayDemandLoading}
      keyField="_id"
    />
  )
}

BusMaintenanceStayDemandTable.propTypes = {
  busMaintenanceStayDemand: PropTypes.oneOfType([
    PropTypes.instanceOf(Immutable.Map),
    PropTypes.object,
    PropTypes.array,
  ]),

  busMaintenanceStayDemandLoading: PropTypes.bool,
  dispatchGetBusMaintenanceStayDemand: PropTypes.func.isRequired,
  dispatchClearBusMaintenanceStayDemand: PropTypes.func.isRequired,
}

BusMaintenanceStayDemandTable.defaultProps = {
  busMaintenanceStayDemand: null,
  busMaintenanceStayDemandLoading: false,
}

const mapStateToProps = ({ MechanicalMaintenanceUnit }) => {
  let busMaintenanceStayDemand = null;

  try {
    busMaintenanceStayDemand = MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
      'busMaintenanceStayDemand',
      'content',
    ]);
  } catch (e) {
    try {
      busMaintenanceStayDemand = MechanicalMaintenanceUnit.BusMaintenanceStay.get('busMaintenanceStayDemand');
    } catch (err) {
      try {
        busMaintenanceStayDemand = MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
          'demand',
          'content',
        ]);
      } catch (error) {
        busMaintenanceStayDemand = null;
      }
    }
  }

  return {
    busMaintenanceStayDemand,
    busMaintenanceStayDemandLoading: MechanicalMaintenanceUnit.BusMaintenanceStay.getIn([
      'busMaintenanceStayDemand',
      'loading',
    ]),
  }
}

const mapDispatchToProps = {
  dispatchGetBusMaintenanceStayDemand: getBusMaintenanceStayDemand,
  dispatchClearBusMaintenanceStayDemand: clearBusMaintenanceStayDemand,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BusMaintenanceStayDemandTable);
